import Vue from 'vue'
import dayjs from 'dayjs'
require('dayjs/locale/ar')

dayjs.extend(require('dayjs/plugin/isSameOrBefore'))
dayjs.extend(require('dayjs/plugin/isSameOrAfter'))

Vue.prototype.$dayjs = dayjs
